import { AngularFireStorage } from '@angular/fire/storage';
import { Injectable } from '@angular/core';

import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { Observable, combineLatest } from 'rxjs';
import { finalize, map, tap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { environment } from '../../../../../../environments/environment';
import { Utils } from 'src/app/core/resources/utils';
import { ThirdParty, ThirdPartyAddress } from 'src/app/core/interfaces/thirdParty';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { FormThirdPartyConsignmentComponent } from '../form-third-party-consignment/form-third-party-consignment.component';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyConsignmentService {

  static thirdPartyMunicipalityCodes: { [key: string]: string } = {};
  constructor(
    private http: HttpClient,
    private endpointResources: Endpoints,
    public utils: Utils,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService
  ) { }

  getThirdPartiesByParent(
    pageKey?: number,
    pageSize?: number,
    ministryRetry?: boolean,
    ministryManualAdjustment?: boolean
  ): Observable<Array<ThirdParty>> {
    let params = new HttpParams();
    if (this.utils.isDefined(pageKey)) params = params.append('pageKey', pageKey.toString());
    if (this.utils.isDefined(pageSize)) params = params.append('pageSize', pageSize.toString());
    if (this.utils.isDefined(ministryRetry)) params = params.append('ministryRetry', ministryRetry.toString());
    if (this.utils.isDefined(ministryManualAdjustment)) params = params.append('ministryManualAdjustment', ministryManualAdjustment.toString());
    return this.http.get<Array<ThirdParty>>(
      environment.urlServerTeclogi + this.endpointResources.thirdParties,
      { params }
    );
  }

  getThirdPartiesAddressByCompany(
    companyId?: string,
    pageKey?: number,
    pageSize?: number,
    city?: string,
    ministryManualAdjustment?: boolean,
    address?: string,
    ministryRetry?: boolean
  ): Observable<ThirdPartyAddress[]> {
    let params = new HttpParams();
    if (companyId) params = params.append('companyId', companyId);
    if (this.utils.isDefined(pageKey)) params = params.append('pageKey', pageKey.toString());
    if (pageSize) params = params.append('pageSize', pageSize.toString());
    if (this.utils.isDefined(city)) params = params.append('city', city);
    if (this.utils.isDefined(ministryRetry)) params = params.append('ministryRetry', ministryRetry.toString());
    if (this.utils.isDefined(ministryManualAdjustment)) params = params.append('ministryManualAdjustment', ministryManualAdjustment.toString());
    if (address) params = params.append('address', address);
    return this.http.get<ThirdPartyAddress[]>(
      environment.urlServerTeclogi + this.endpointResources.thirdPartiesAddress,
      { params }
    ).pipe(
      map((addresses) => (Array.isArray(addresses) ? addresses : []))
    );
  }

  createThirdParty(data: any): Observable<ThirdPartyAddress> {
    return this.http.post<ThirdPartyAddress>(
      environment.urlServerTeclogi + this.endpointResources.thirdParties,
      data
    );
  }

  setLatLngAddresses(data: ThirdPartyAddress): Observable<ThirdPartyAddress> {
    return this.http.put<ThirdPartyAddress>(
      environment.urlServerTeclogi + this.endpointResources.thirdPartiesUpdate,
      data
    )
  }


  editThirdPartyAddressDialog(thirdParty: ThirdParty, thirdPartyAddress: ThirdPartyAddress, options: { disableCityEdition?: boolean, alertMessage?: string, isInternational?: boolean }, callback?: (response?: ThirdPartyAddress) => void): void {
    const documentTypeName = this.utils.getNestedValue(thirdPartyAddress, 'information.documentTypeName');
    const documentTypeId = this.utils.getNestedValue(thirdPartyAddress, 'information.documentTypeId');
    const addressInformationName = this.utils.getNestedValue(thirdPartyAddress, 'information.name');
    const name = addressInformationName || (thirdParty && thirdParty.name);
    const municipalityCode = this.utils.getNestedValue(thirdPartyAddress, 'municipalityCode');
    const address = this.utils.getNestedValue(thirdPartyAddress, 'address.address');
    const location = this.utils.getNestedValue(thirdPartyAddress, 'address.location');
    const branchOfficeName = this.utils.getNestedValue(thirdPartyAddress, 'branchOfficeName');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      newThirdParty: true,
      title: 'Editar Sede/Dirección de tercero',
      exactTitle: true,
      options: {
        thirdParty: { ...thirdParty, documentTypeName, documentTypeId, name },
        city: { municipalityCode },
        address: { address, location },
        branchOfficeName,
        disableCityEdition: options && options.disableCityEdition ? options.disableCityEdition : false,
        alertMessage: options && options.alertMessage ? options.alertMessage : '',
        isInternational: !!(options && options.isInternational)
      },
      type: 'edit'
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(FormThirdPartyConsignmentComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state && result.data) {
        const thirdPartyToSend = this.utils.clone(thirdPartyAddress);
        if (result.data.address) thirdPartyToSend.address['address'] = result.data.address.address;
        if (result.data.address && result.data.address.location && result.data.address.location.lat && result.data.address.location.lng) thirdPartyToSend.address.location = {
          lat: Number(result.data.address.location.lat),
          lng: Number(result.data.address.location.lng)
        }
        if (result.data.branchOfficeName) thirdPartyToSend.branchOfficeName = result.data.branchOfficeName;
        if (result.data.municipalityCode) thirdPartyToSend.municipalityCode = result.data.municipalityCode;
        this.editThirdPartyAddress(thirdPartyToSend, callback);
      }
    });
  }

  editThirdPartyAddress(body: ThirdPartyAddress, callback?: (response?: ThirdPartyAddress) => void): void {
    this.spinner.show();
    this.setLatLngAddresses(body).subscribe({
      next: async (response: ThirdPartyAddress) => {
        this.spinner.hide();
        const rndcError = this.getRndcError(response);
        if (rndcError) {
          this.snackBarService.openSnackBar(rndcError, undefined, 'error');
          return;
        }
        if (callback) callback(response);
        else this.snackBarService.openSnackBar(FormMessages.ADDRESS_LOCATION_SETTED);
      },
      error: (error) => {
        this.spinner.hide();
        const rndcError = this.getRndcError(error);
        this.snackBarService.openSnackBar(rndcError || ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    });
  }

  private getRndcError(response: any): string {
    return this.utils.getNestedValue(response, 'errorRNDC.error') ||
      this.utils.getNestedValue(response, 'error.errorRNDC.error') ||
      this.utils.getNestedValue(response, 'error.error.errorRNDC.error');
  }


  updateThirdPartyAddressState(addressId: string, active: boolean, description?: string): Observable<{ message: string }> {
    let params = new HttpParams();
    params = params.append('addressId', addressId);
    params = params.append('active', active.toString());
    const descriptionToSend = description || 'Active';
    params = params.append('description', descriptionToSend);
    return this.http.put<{ message: string }>(
      `${environment.urlServerTeclogi}${this.endpointResources.thirdPartiesAddressUpdateState}`,
      {},
      { params }
    );
  }

}
